var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldShopAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99 17.338v-2.84a.96.96 0 0 1 1.29-.9c.26.09.52.15.79.19.12.02.24.04.36.04.15.02.31.03.46.03 1.11 0 2.21-.41 3.08-1.12.83.71 1.9 1.12 3.04 1.12 1.14 0 2.2-.39 3.03-1.11.86.7 1.94 1.11 3.04 1.11.17 0 .35-.01.51-.03.12-.01.22-.02.33-.04.3-.04.57-.12.84-.21a.96.96 0 0 1 1.27.9v2.86c0 2.65-2.15 4.81-4.81 4.81H7.8c-2.65 0-4.81-2.15-4.81-4.81z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 5.932c-.4-2.9-1.72-4.08-4.54-4.08H6.82c-2.82 0-4.13 1.18-4.54 4.11l-.26 2.64c-.1 1.03.18 2.03.79 2.81.73.95 1.85 1.49 3.1 1.49 1.21 0 2.37-.61 3.1-1.58.65.97 1.77 1.58 3.01 1.58 1.24 0 2.33-.58 2.99-1.54.74.95 1.88 1.54 3.08 1.54 1.28 0 2.43-.57 3.15-1.57.58-.77.84-1.74.74-2.74l-.28-2.66zm-8.95 1.8v.78a.749.749 0 1 1-1.5 0v-.78h-.75a.749.749 0 1 1 0-1.5h.75v-.71c0-.41.34-.75.75-.75s.75.34.75.75v.71h.75a.749.749 0 1 1 0 1.5h-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldShopAdd);
export default __webpack_public_path__ + "static/media/vuesax-bold-shop-add.9f15073f78d35e7b1e54b75b18c929ed.svg";
export { ForwardRef as ReactComponent };